@if (showPasswordToggle() && fieldType() === 'password') {
    <p-inputgroup class="w-full">
  <p-floatlabel variant="on">
      <input pInputText
             [attr.autocomplete]="autocomplete()"
             [formControl]="inputFormControl()"
             [type]="passwordType()"
             [id]="inputId()"

             class="w-full"/>
    <label [for]="inputId()">{{label()}}</label>
  </p-floatlabel>
      <p-inputgroup-addon>
        <button type="button"
                pButton
                severity="contrast"
                [text]="true"
                [rounded]="true"
                (click)="togglePasswordVisibility()">
          <i pButtonIcon [class]="passwordVisible() ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
        </button>
      </p-inputgroup-addon>
    </p-inputgroup>
} @else {
  <p-floatlabel variant="on">
    <input pInputText
           [attr.autocomplete]="autocomplete()"
           [formControl]="inputFormControl()"
           [type]="fieldType()"
           [id]="inputId()"
           class="w-full"/>
    <label [for]="inputId()">{{label()}}</label>
  </p-floatlabel>
}
@let error = visibleErrorMessage();
@if (error) {
    <p class="text-red-500 text-sm">{{error}}</p>
}
